import axios, { ResponseType } from 'axios';
import { APP_CONFIG } from '@/config/app-config';
import authProvider from '@/utility/authProvider';

export default class HttpClient {
    public static instance(responseType?: ResponseType) {
        const baseURL = `${APP_CONFIG.baseDomain}/client`;
        const httpClient = axios.create({
            baseURL,
            headers: authProvider.isToken() ? {'Authorization': `Bearer ${authProvider.getToken()}` } : null,
            responseType
        });
        return httpClient;
    }

    public static request_payload(param) {
        let query = '';
        if (
            param &&
            (param.pagination || param.qObject || param.filter || param.quickFilter)
        ) {
            const page =
                param.pagination && param.pagination.page ? param.pagination.page : 1;
            const rowsPerPage =
                param.pagination && param.pagination.itemsPerPage
                    ? param.pagination.itemsPerPage
                    : 1000000;
            const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID';
            const descending = param.pagination ? param.pagination.sortDesc[0] : 1;
            const qObject = param.qObject
                ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString(
                    'base64'
                )
                : '';
            const filter =
                param.filter && param.filter.length > 0
                    ? Buffer.from(JSON.stringify({ filter: param.filter })).toString(
                        'base64'
                    )
                    : '';
            const quickFilter =
                param.quickFilter && param.quickFilter.length > 0
                    ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString(
                        'base64'
                    )
                    : '';
            query = `?filter=${filter}&qObject=${qObject}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${quickFilter}`;

            if ('startTime' in param) {
                query += `&startTime=${param.startTime}`;
            }
            if ('endTime' in param) {
                query += `&endTime=${param.endTime}`;
            }
            if ('staffName' in param) {
                query += `&staffName=${param.staffName}`;
            }
            if ('method' in param) {
                query += `&method=${param.method}`;
            }
            if ('tab' in param) {
                query += `&tab=${param.tab}`;
            }
            if ('is_master' in param) {
                query += `&is_master=${param.is_master}`;
            }
        } else if (param && param.is_master) {
            const isMaster = param.is_master || '';
            const fields = param.fields || [];
            query = `?is_master=${isMaster}&fields=${fields.join(',')}`;
        } else if (param) {
            const fields: any[] = [];
            Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
            query = `?${fields.join('&')}`;
        }

        if (param && 'bell' in param) {
            query += `&bell=${param.bell}`;
        }
        return query;
    }
}